export const mail = "info@philmeinwelt.com";



export const imageData = [
    {
        name: 'map',
        title: 'Berlin',
        format: 'portrait',
        shortDescription: 'berlin',
        longDescription: 'Berlin',
        image: 'map/map.png',
        category: 'Image',
        batches: {
            featured: false,
        },
    },
];

export const aboutMeComponentData = [
    {
        name: 'aboutme-main',
        category: 'AboutMe',
        title: 'Hi, I am Phil!',
        longDescription: 'I turn ideas into working products. As a Full-Stack Developer focused on AI and automation, I handle the technical side so founders can focus on vision.',
        portraitImage: '../src/aboutme/phil.jpg',
        batches: {
            featured: false,
        },
    },
];

export const socialIconComponentData = [
    // {
    //     category: 'SocialIcon',
    //     name: 'github',
    //     icon: 'icons/github/GitHub-Mark-Light-64px.png',
    //     color: '#000',
    //     link: 'https://github.com/ppphiiil',
    //     batches: {
    //         featured: false,
    //     },
    // },
    {
        category: 'SocialIcon',
        name: 'linkedin',
        icon: 'icons/linkedin.png',
        color: '#fff',
        link: 'https://www.linkedin.com/in/phil-meinwelt-moser/',
        batches: {
            featured: false,
        },
    },
];

export const articlesData = [
    {
        category: 'Article',
        title: 'This is an Article',
        shortDescription: 'I created a copy of the IKEA website',
        longDescription: 'I was interessted in creating a website with customer requirements. So I decided to take the ikea Website as a customer requirements and it has to look like this.',
        date: '10.02.2021',
        linkName: 'Read more',
        batches: {
            featured: false,
        },
    },
    {
        category: 'Article',
        title: 'This is another Article',
        shortDescription: 'I was interessted in creating a website with customer requirements. So I decided to take the',
        longDescription: 'I was interessted in creating a website with customer requirements. So I decided to take the ikea Website as a customer requirements and it has to look like this.',
        date: '10.02.2021',
        linkName: 'Read more',
        batches: {
            featured: false,
        },
    },
];

export const repoTestData = {
    "data": {
        "repoData": {
            "data": [
                {
                    "size": 47230,
                    "private": false,
                    "name": "-pawfect-pet-adoption-website",
                    "description": "My last group-project is a adoption platform for pets. I collaborated with 4 other students from DCI for our final project.",
                    "githubUsername": "ppphiiil",
                    "homepage": "https://pawfect.netlify.app/",
                    "stargazers_count": 1,
                    "topics": [
                        "full-stack",
                        "nodejs",
                        "express",
                        "mongodb-atlas",
                        "react",
                        "mern-stack",
                        "teamwork",
                        "asdasdasdsdas",
                        "asdasdasdasd",
                        "asdasdasd",
                        "asdasd",
                        "as",
                        "asd",
                        "a",
                        "sda",
                        "sdas",
                        "das",
                        "dasdasd"
                    ],
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/-pawfect-pet-adoption-website/master/Screen%20Shot%202021-10-05%20at%2014.31.21.png",
                    "languages": {
                        "JavaScript": 104878,
                        "SCSS": 26956,
                        "HTML": 2074
                    }
                },
                {
                    "size": 7183,
                    "private": false,
                    "name": "-Userplatform",
                    "description": "User get listed with their Profiles. They can register/login and edit profile.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "frontend",
                        "login",
                        "antdesign",
                        "react",
                        "semantic-ui-react",
                        "uuid"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/-Userplatform",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/-Userplatform/master/homepage.png",
                    "languages": {
                        "JavaScript": 46745,
                        "SCSS": 21087,
                        "HTML": 645,
                        "CSS": 614
                    }
                },
                {
                    "size": 6090,
                    "private": false,
                    "name": "-Blog",
                    "description": "A simple Blog with markdown Editor. You can add, edit and delete postings.",
                    "githubUsername": "ppphiiil",
                    "homepage": "https://nameless-fjord-30667.herokuapp.com/",
                    "stargazers_count": 1,
                    "topics": [
                        "express",
                        "mongodb-atlas",
                        "blog",
                        "ejs-templates",
                        "mongoose",
                        "dompurify",
                        "full-stack",
                        "mern-stack"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Blog",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/-Blog/master/1%20blog.png",
                    "languages": {
                        "JavaScript": 8490,
                        "EJS": 4787
                    }
                },
                {
                    "size": 79821,
                    "private": false,
                    "name": "Image-carousel",
                    "description": null,
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Image-carousel",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Image-carousel/master/images/image1.jpg",
                    "languages": {
                        "CSS": 1760,
                        "JavaScript": 1503,
                        "HTML": 847
                    }
                },
                {
                    "size": 5421,
                    "private": false,
                    "name": "Ecommerce-Filter",
                    "description": "multi-filter for filtering size and colors of a ecommerce shop. I only used frontend to solve it.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "frontend",
                        "bootstrap",
                        "react",
                        "antdesign",
                        "reactrouterdom"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Ecommerce-Filter",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Ecommerce-Filter/master/main-image.png",
                    "languages": {
                        "JavaScript": 25063,
                        "CSS": 2882,
                        "HTML": 289
                    }
                },
                {
                    "size": 533,
                    "private": false,
                    "name": "Markdown-Editor",
                    "description": "Translate Markdown to HTML",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "bootstrap",
                        "react",
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Markdown-Editor",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Markdown-Editor/master/main-image.png",
                    "languages": {
                        "JavaScript": 1658,
                        "HTML": 288
                    }
                },
                {
                    "size": 1884,
                    "private": false,
                    "name": "-ikea-copy",
                    "description": "I like to copy websites from well known brands :) Here are some elements from Ikea website. I focused on making a nice responsive menu.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 2,
                    "topics": [
                        "front-end",
                        "usecontext-hook",
                        "semantic-ui-react",
                        "react",
                        "responsive-layout"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/-ikea-copy",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/-ikea-copy/master/animation.gif",
                    "languages": {
                        "JavaScript": 12222,
                        "SCSS": 10670,
                        "HTML": 574
                    }
                },
                {
                    "size": 1261,
                    "private": false,
                    "name": "-Search-an-Image-Database",
                    "description": "Working with an Image Database API. Here you can find Images by keywords. ex. \"cars\"",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "api",
                        "frontend",
                        "react",
                        "axios"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/-Search-an-Image-Database",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/-Search-an-Image-Database/master/main-image.png",
                    "languages": {
                        "JavaScript": 3501,
                        "HTML": 1833,
                        "CSS": 520
                    }
                },
                {
                    "size": 13235,
                    "private": false,
                    "name": "bulls-and-cows-gamex",
                    "description": "In this Browsergame I built a two player game that is called Bulls and Cows.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/bulls-and-cows-game",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/bulls-and-cows-gamex/master/main-image.png",
                    "languages": {
                        "JavaScript": 22444,
                        "SCSS": 8977,
                        "HTML": 4608
                    }
                },
                {
                    "size": 43,
                    "private": false,
                    "name": "List-Filter",
                    "description": "Exercise: Filter a List of data with different inputs.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "async",
                        "frontend",
                        "promises",
                        "api"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/List-Filter",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/List-Filter/master/Screen%20Shot%202021-09-01%20at%2001.24.05.png",
                    "languages": {
                        "JavaScript": 7052,
                        "HTML": 1690,
                        "CSS": 639
                    }
                },
                {
                    "size": 4229,
                    "private": false,
                    "name": "Make-it-responsive",
                    "description": "Just a little responsive Website. Starting thinking responsive.",
                    "githubUsername": "ppphiiil",
                    "homepage": "https://ppphiiil.github.io/Make-it-responsive/",
                    "stargazers_count": 1,
                    "topics": [
                        "responsive-layout",
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Make-it-responsive",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Make-it-responsive/master/animation10.gif",
                    "languages": {
                        "CSS": 3495,
                        "HTML": 2131,
                        "JavaScript": 291
                    }
                },
                {
                    "size": 1931,
                    "private": false,
                    "name": "Popup",
                    "description": "I created a Popup. It is responsive with flexbox only.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "responsive-layout",
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Popup",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Popup/master/1-main-image.png",
                    "languages": {
                        "SCSS": 2699,
                        "HTML": 1541
                    }
                },
                {
                    "size": 217,
                    "private": false,
                    "name": "Ad-Banner",
                    "description": "I saw a Ad Banner on a Website and I was motivated to make a copy. Nice clean hover :) learning html and css with exact requirements! Love it! ",
                    "githubUsername": "ppphiiil",
                    "homepage": "https://ppphiiil.github.io/Ad-Banner/",
                    "stargazers_count": 2,
                    "topics": [
                        "frontend",
                        "copy-famous-website",
                        "flexbox"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Ad-Banner",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Ad-Banner/master/animation6.gif",
                    "languages": {
                        "CSS": 1952,
                        "HTML": 1035
                    }
                },
                {
                    "size": 209,
                    "private": false,
                    "name": "Feature-Cards",
                    "description": "Learning flexbox and creating some really nice looking Feature Cards.",
                    "githubUsername": "ppphiiil",
                    "homepage": "https://ppphiiil.github.io/Feature-Cards/",
                    "stargazers_count": 1,
                    "topics": [
                        "responsive-layout",
                        "flexbox",
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Feature-Cards",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Feature-Cards/main/main-image.png",
                    "languages": {
                        "HTML": 2525,
                        "CSS": 1649
                    }
                },
                {
                    "size": 1938,
                    "private": false,
                    "name": "Userfriendly-Login-Form",
                    "description": "*in progress* How to make a user friendly Login-Form. I did a research and going to finish it step by step.",
                    "githubUsername": "ppphiiil",
                    "homepage": "",
                    "stargazers_count": 1,
                    "topics": [
                        "frontend"
                    ],
                    "deploymentlink": "https://ppphiiil.github.io/Userfriendly-Login-Form",
                    "mainimage": "https://raw.githubusercontent.com/ppphiiil/Userfriendly-Login-Form/master/main-image.png",
                    "languages": {
                        "HTML": 2598,
                        "CSS": 2179,
                        "JavaScript": 1
                    }
                }
            ],
            "countedLanguages": {
                "HTML": 14,
                "JavaScript": 12,
                "CSS": 9,
                "SCSS": 5,
                "EJS": 1
            },
            "countedTopics": {
                "frontend": 12,
                "react": 6,
                "responsive-layout": 4,
                "full-stack": 2,
                "express": 2,
                "mongodb-atlas": 2,
                "mern-stack": 2,
                "antdesign": 2,
                "semantic-ui-react": 2,
                "bootstrap": 2,
                "api": 2,
                "flexbox": 2,
                "nodejs": 1,
                "teamwork": 1,
                "asdasdasdsdas": 1,
                "asdasdasdasd": 1,
                "asdasdasd": 1,
                "asdasd": 1,
                "as": 1,
                "asd": 1,
                "a": 1,
                "sda": 1,
                "sdas": 1,
                "das": 1,
                "dasdasd": 1,
                "login": 1,
                "uuid": 1,
                "blog": 1,
                "ejs-templates": 1,
                "mongoose": 1,
                "dompurify": 1,
                "reactrouterdom": 1,
                "front-end": 1,
                "usecontext-hook": 1,
                "axios": 1,
                "async": 1,
                "promises": 1,
                "copy-famous-website": 1
            }
        },
        "ownerData": {
            "avatar_url": "https://avatars.githubusercontent.com/u/71499744?v=4",
            "id": 71499744,
            "github_url": "https://github.com/ppphiiil",
            "username": "ppphiiil",
            "bio": "Hi, I am Phil!\r\nFull-Stack Developer with 4 years of experience as Managing Director and 10 years as Freelance Producer in the advertising industry who recently",
            "company": "DCI",
            "email": null,
            "location": "Berlin",
            "name": "Phil",
            "public_repos": 36,
            "repos_url": "https://api.github.com/users/ppphiiil/repos",
            "twitter_username": "twitter",
            "githubApi_url": "https://api.github.com/users/ppphiiil"
        }
    },
   
}
